import moment from 'moment'
import Vue from 'vue'

export const validateName = (name) => {
  const pattern = /^[a-zA-Z0-9'\.\-,\$\ ]+$/
  return pattern.test(name)
}

export const validateEmail = (email) => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}

export const validatePassword = (password) => {
  const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/
  return pattern.test(password)
}

export const validateSpecialChars = (value) => {
  const pattern = /\`|\~|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\+|\=|\[|\{|\]|\}|\||\\|\'|\<|\,|\.|\>|\?|\/|\""|\;|\:|\-|\_/
  return !pattern.test(value)
}

export const validateNumbers = (value) => {
  const pattern = /^[0-9]+$/g
  return pattern.test(value)
}
export function capitalizeFirstLetter (title) {
  if (!title) return ''
  return title[0].toUpperCase() + title.slice(1)
}

export function forwardMonth (arr, realDataIsUntil = 'April 2020') {
  const currentDate = {
    month: moment().format('M'),
    year: moment().format('YYYY')
  }
  const endDate = {
    month: moment(realDataIsUntil).format('M'),
    year: moment(realDataIsUntil).format('YYYY')
  }
  const shiftForward = currentDate.year - endDate.year === 0 ? currentDate.month - endDate.month : currentDate.month - endDate.month + ((currentDate.year - endDate.year) * 12)
  return arr && arr.map(i => {
    return {
      ...i,
      month: Number(`${moment(`${Number(i.month)} ${i.year}`, 'MM YYYY').add(shiftForward, 'month').format('M')}`),
      year: Number(`${moment(`${Number(i.month)} ${i.year}`, 'MM YYYY').add(shiftForward, 'month').format('YYYY')}`)
    }
  })
}

export function numberWithCommas (x) {
  return parseFloat(x).toLocaleString()
}

export function sortAlphabetically (arr, key) {
  if (key) {
    return arr && arr.sort(function (a, b) {
      if (a[key] < b[key]) { return -1 }
      if (a[key] > b[key]) { return 1 }
      return 0
    })
  }
  return arr && arr.sort(function (a, b) {
    if (a < b) { return -1 }
    if (a > b) { return 1 }
    return 0
  })
}

export function sortArrayWithString (arr, key) {
  return arr && arr.sort((a, b) => a[key] - b[key])
}
export function addMissingBins (arr1, arr2, incValue, isAgeBin) {
  if (arr2 && arr2.length) {
    const remainingSizes = arr1.filter(newSize => !arr2.some(size => size.label === newSize))

    if (remainingSizes && remainingSizes.length) {
      const emptyBins = remainingSizes.map(size => {
        return {
          db_group_value: arr1.indexOf(size) + incValue,
          extension_labels: isAgeBin ? [] : null,
          size: isAgeBin ? [] : null,
          label: size,
          total_count: 0,
          total_size: 0
        }
      })
      return [
        ...arr2,
        ...emptyBins
      ]
    } else {
      return arr2
    }
  }

  return arr2
}

export function convert (totalSize, flag, check, decimals = 2) {
  let value = 0
  let char = ''
  if (totalSize >= Math.pow(check, 4)) {
    value = totalSize / (Math.pow(check, 4))
    char = flag === 'GB' ? 'TB' : 'T'
  } else if (totalSize >= Math.pow(check, 3)) {
    value = totalSize / (Math.pow(check, 3))
    char = flag === 'GB' ? 'GB' : 'B'
  } else if (totalSize >= Math.pow(check, 2)) {
    value = totalSize / (Math.pow(check, 2))
    char = flag === 'GB' ? 'MB' : 'M'
  } else if (totalSize >= check) {
    value = totalSize / (check)
    char = flag === 'GB' ? 'KB' : 'K'
  } else {
    value = totalSize
    char = flag === 'GB' ? 'B' : ''
  }
  if (!Number.isInteger(value)) {
    value = parseFloat(value).toFixed(decimals)
  }
  return `${value}${char}`
}

export function formattedDateTime (formatDate, format = 'YYYY-MM-DD hh:mm:ss') {
  return moment(formatDate).format(format)
}

export function dateDiffDays (date1, date2) {
  var startDate = moment(date1)
  var endDate = moment(date2)
  return moment.duration(endDate.diff(startDate)).asDays()
}
export function errorNotification (message) {
  Vue.notify({
    group: 'messages',
    type: 'error',
    text: message
  })
}
